import{w as e}from"./lit-element-e382250e.js";function t(t,r=t,n=e){return t?r:n}export{t as c};
//# sourceMappingURL=cond-ed8742b5.js.map
